export const POSITIONS = [
  "P",
  "C",
  "1B",
  "2B",
  "SS",
  "3B",
  "LF",
  "LC",
  "RC",
  "RF",
] as const;

export type DefensePosition = (typeof POSITIONS)[number];

export function isDefensePosition(value: unknown): value is DefensePosition {
  return POSITIONS.some((position) => position === value);
}
